import axios from "axios";
import axiosRetry from "axios-retry";

axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    // // Authorization: "JWT " + localStorage.getItem("accessToken"),
    "Content-Type": "application/json",
    accept: "application/json",
  },
});

axiosRetry(axiosInstance, { retries: 3 });

//failsafe cleanup
const handleDeadSession = (logMessage, errorToReject) => {
  console.error(logMessage, errorToReject);
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  window.location.href = "/shop/login";
  return Promise.reject(errorToReject);
}

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token && token !== "undefined" && token !== "null") {
      config.headers.Authorization = `JWT ${token}`;
    } else {
      //Force a clean state for guest requests
      delete config.headers.Authorization;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const originalRequest = error.config;

    //immediate exit if refresh endpoint itself throw http err
    if (originalRequest.url && originalRequest.url.includes("users/token/refresh/")) {
      return handleDeadSession("Refresh token endpoint rejected. Clearing dead session...", error);
    }

    if (!originalRequest._retryCounter) {
      originalRequest._retryCounter = 0;
    }

    if (
      error && error.response &&
      (error.response.status === 401 || error.response.status === 403) &&
      (error.response.statusText === "Unauthorized" ||
        error.response.statusText === "Forbidden") &&
      originalRequest._retryCounter <= 3
    ) {
      const refresh_token = localStorage.getItem("refreshToken");
      originalRequest._retryCounter += 1;
      return axiosInstance
        .post("users/token/refresh/", { refresh: refresh_token })
        .then((response) => {
          localStorage.setItem("accessToken", response.data.access);
          localStorage.setItem("refreshToken", response.data.refresh);

          axiosInstance.defaults.headers["Authorization"] =
            "JWT " + response.data.access;
          originalRequest.headers["Authorization"] =
            "JWT " + response.data.access;
          return axiosInstance(originalRequest);
        })
        .catch((err) => {
          //safe for wifi drops: Just log the network/server issue
          console.error("Network connection or server error during token refresh:", err);

          //keep the tokens safe in local storage so they can retry when internet returns
          return Promise.reject(err);
        });
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
